module.exports = __webpack_public_path__ + "static/media/mcm3.0b42bb46.PNG";